import { graphql, useStaticQuery } from 'gatsby'

const allContentfulComponentMainNavBanner = () => {
  return useStaticQuery(graphql`
    {
      allContentfulComponentMainNavBanner(sort: { fields: publishDate, order: ASC }) {
        edges {
          node {
            __typename
            id
            node_locale
            entryLocale
            useCase
            eyebrow
            title
            subtitle
            description
            textAlignment
            icon {
              ...wrapperAsset
            }
            image {
              ...wrapperAsset
            }
            theme
            cta {
              ... on Node {
                ...topicCTA
                ...internalLink
              }
            }
            displayCta
            publishDate
            unpublishDate
          }
        }
      }
    }

    fragment wrapperAsset on ContentfulWrapperAsset {
      __typename
      id
      altText
      image {
        file {
          url
        }
      }
    }

    fragment topicCTA on ContentfulTopicCta {
      __typename
      id
      externalUrl
      text
      description
      internalLink {
        ... on Node {
          ... on ContentfulPageAboutRpa {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageBlogPost {
            __typename
            id
            name
            slug
            blogCategory {
              seoMetadata {
                pageCanonicalUrl
              }
            }
          }
          ... on ContentfulPageCompanyListing {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageDownload {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageFlex {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageLegal {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageMainBlog {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageNewsroomArticle {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPagePartner {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPagePlaceholder {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageProduct {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageResource {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageResourceDemo {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageResourceListing {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageSolutions {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageWhitePaper {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulTopicAnchorLink {
            __typename
            contentful_id
            name
            identifier
          }
          ... on ContentfulWrapperPdf {
            __typename
            id
            name
            slug
          }
        }
      }
    }

    fragment internalLink on ContentfulTopicInternalLink {
      __typename
      id
      ctaText
      internalLink {
        ... on Node {
          ... on ContentfulHomepage {
            __typename
            slug
            id
            name
          }
          ... on ContentfulPageAboutRpa {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageAnalystReport {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageBlogPost {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageCompanyListing {
            __typename
            slug
            id
            name
          }
          ... on ContentfulPageDownload {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageFlex {
            __typename
            slug
            id
            name
          }
          ... on ContentfulPageLegal {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageMainBlog {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageNewsroomArticle {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPagePartner {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageProduct {
            __typename
            slug
            id
            name
          }
          ... on ContentfulPageResourceDemo {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageResourceListing {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageSolutions {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageWebinarRecording {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageWhitePaper {
            __typename
            slug
            id
            name
            pageName
          }
        }
      }
    }
  `)
}

export default { allContentfulComponentMainNavBanner }
